var render = function () {
  var _vm$orderDetail$order, _vm$orderDetail$order2, _vm$orderDetail$order3, _vm$orderDetail, _vm$orderDetail$payme, _vm$orderDetail2, _vm$orderDetail2$paym, _vm$orderDetail3, _vm$orderDetail4, _vm$orderDetail5, _vm$orderDetail5$orde, _vm$orderDetail$order4, _vm$orderDetail$order5, _vm$orderDetail$order6, _vm$orderDetail$order7, _vm$orderDetail$order8, _vm$orderDetail$order9, _vm$orderDetail$order10, _vm$orderDetail6, _vm$orderDetail6$orde, _vm$orderDetail6$orde2, _vm$orderDetail7, _vm$orderDetail7$orde, _vm$orderDetail7$orde2, _vm$orderDetail8, _vm$orderDetail8$orde, _vm$orderDetail8$orde2, _vm$orderDetail9, _vm$orderDetail9$orde, _vm$orderDetail9$orde2, _vm$orderDetail10, _vm$orderDetail10$ord, _vm$orderDetail11, _vm$orderDetail11$ord, _vm$orderDetail11$ord2, _vm$orderDetail12, _vm$orderDetail12$ord, _vm$orderDetail12$ord2, _vm$orderDetail13, _vm$orderDetail13$ord, _vm$orderDetail13$ord2, _vm$orderDetail14, _vm$orderDetail14$ord, _vm$orderDetail14$ord2, _vm$orderDetail15, _vm$orderDetail15$ord, _vm$orderDetail16, _vm$orderDetail17, _vm$orderDetail17$pri, _vm$orderDetail18, _vm$orderDetail18$pri, _vm$orderDetail19, _vm$orderDetail19$pri, _vm$orderDetail20, _vm$orderDetail20$pri, _vm$orderDetail21, _vm$orderDetail21$pri, _vm$orderDetail22, _vm$orderDetail22$pri, _vm$orderDetail22$pri2, _vm$orderDetail23, _vm$orderDetail23$pri, _vm$orderDetail23$pri2, _vm$orderDetail24, _vm$orderDetail24$pri, _vm$orderDetail25, _vm$orderDetail25$pri, _vm$orderDetail26, _vm$orderDetail26$pay, _vm$orderDetail27, _vm$orderDetail27$pay, _vm$orderDetail28, _vm$orderDetail28$pay, _vm$orderDetail29, _vm$orderDetail29$pay, _vm$orderDetail30, _vm$orderDetail30$pay, _vm$orderDetail31, _vm$orderDetail31$pay, _vm$orderDetail32, _vm$orderDetail32$pay, _vm$orderDetail33;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order text-neutral-500"
  }, [_c('div', {
    staticClass: "bg-white mb-40"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col justify-between gap-4 mdmax:gap-6 items-center mdmax:items-start p-6 shadow-border-b"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col items-start gap-4 mdmax:gap-3 w-1/2 mdmax:w-full"
  }, [_c('div', {
    staticClass: "flex-shrink-0"
  }, [_c('span', {
    staticClass: "inline-flex justify-center items-center px-3 py-1.5 text-xs font-semibold rounded-md shadow-sm",
    style: 'backgroundColor: ' + _vm.orderDetail.status_color + '; color: white;'
  }, [_vm._v(_vm._s(_vm.orderDetail.status_display))])]), _c('div', {
    staticClass: "w-full min-w-0"
  }, [_c('span', {
    staticClass: "text-neutral-500 text-xs block mb-2"
  }, [_vm._v(_vm._s(_vm.orderDetail.created_time_display) + " / " + _vm._s(_vm.orderDetail.order_id))]), _c('div', {
    staticClass: "flex items-center flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "bg-neutral-100 border border-neutral-200 rounded text-xs px-2 py-1 max-w-full"
  }, [_c('span', {
    staticClass: "text-neutral-500"
  }, [_vm._v("AWB Linknau:")]), _c('strong', {
    staticClass: "text-neutral-800 break-all ml-1"
  }, [_vm._v(_vm._s((_vm$orderDetail$order = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order === void 0 ? void 0 : _vm$orderDetail$order.awb))])]), (_vm$orderDetail$order2 = _vm.orderDetail.order_delivery) !== null && _vm$orderDetail$order2 !== void 0 && _vm$orderDetail$order2.external_awb ? _c('div', {
    staticClass: "bg-neutral-100 border border-neutral-200 rounded text-xs px-2 py-1 max-w-full"
  }, [_c('span', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.awbPartner')) + ":")]), _c('strong', {
    staticClass: "text-neutral-800 break-all ml-1"
  }, [_vm._v(_vm._s((_vm$orderDetail$order3 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order3 === void 0 ? void 0 : _vm$orderDetail$order3.external_awb))])]) : _vm._e()])])]), _c('div', {
    staticClass: "w-1/2 mdmax:w-full flex items-center mdmax:items-stretch gap-3 justify-end mdmax:justify-start flex-wrap mdmax:flex-col"
  }, [_vm.canCancelOrder() ? _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": "Batalkan Pesanan",
      "size": "small",
      "type": "delete_outline"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleModalCancelOrder();
      }
    }
  }) : _vm._e(), _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": _vm.$t('order.orderDetail.submitComplaint'),
      "size": "small",
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        return _vm.toggleComplainModal();
      }
    }
  }), ((_vm$orderDetail = _vm.orderDetail) === null || _vm$orderDetail === void 0 ? void 0 : (_vm$orderDetail$payme = _vm$orderDetail.payment_info) === null || _vm$orderDetail$payme === void 0 ? void 0 : _vm$orderDetail$payme.status) === 'settlement' || ((_vm$orderDetail2 = _vm.orderDetail) === null || _vm$orderDetail2 === void 0 ? void 0 : (_vm$orderDetail2$paym = _vm$orderDetail2.payment_info) === null || _vm$orderDetail2$paym === void 0 ? void 0 : _vm$orderDetail2$paym.status) === 'capture' || ((_vm$orderDetail3 = _vm.orderDetail) === null || _vm$orderDetail3 === void 0 ? void 0 : _vm$orderDetail3.status) === 'OHUBCEK' || ((_vm$orderDetail4 = _vm.orderDetail) === null || _vm$orderDetail4 === void 0 ? void 0 : _vm$orderDetail4.status) === 'OPRCD' ? _c('div', {
    staticClass: "flex items-center mdmax:flex-col mdmax:items-stretch gap-4 mdmax:gap-3 mdmax:w-full"
  }, [_c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": "View Receipt",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.previewReceipt();
      }
    }
  }), _c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": "Download Shipping Label",
      "size": "small",
      "icon": function icon() {
        return import('@/components/Icons/Download');
      }
    },
    on: {
      "action": function action($event) {
        return _vm.download();
      }
    }
  })], 1) : _vm._e(), _vm.orderDetail.status === 'OPAYWAIT' ? _c('div', {
    staticClass: "mdmax:w-full"
  }, [_c('Button', {
    staticClass: "mdmax:w-full",
    attrs: {
      "buttonText": _vm.$t('order.orderDetail.continuePayment'),
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.doRetryPayment();
      }
    }
  })], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "flex mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.weightTypePackage')))]), _vm._l((_vm$orderDetail5 = _vm.orderDetail) === null || _vm$orderDetail5 === void 0 ? void 0 : (_vm$orderDetail5$orde = _vm$orderDetail5.order_delivery) === null || _vm$orderDetail5$orde === void 0 ? void 0 : _vm$orderDetail5$orde.packages, function (packageItem, index) {
    return _c('div', {
      key: 'package-' + index,
      staticClass: "flex flex-col gap-3 mb-4 border rounded-md px-3 py-3 bg-neutral-200 last:mb-0"
    }, [_c('div', {
      staticClass: "flex justify-start gap-6"
    }, [_c('div', {
      staticClass: "w-2/5"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.weight')))]), _c('p', [_vm._v(_vm._s(packageItem.weight) + "kg")])]), _c('div', {
      staticClass: "w-3/5"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.type')))]), _c('p', [_vm._v(_vm._s(packageItem.category))])])]), packageItem.dimension ? _c('div', {
      staticClass: "flex justify-start gap-6 border-t border-neutral-300 pt-3"
    }, [_c('div', {
      staticClass: "w-full"
    }, [_c('p', {
      staticClass: "text-sm font-medium mb-1 text-neutral-700"
    }, [_vm._v("Volume Paket")]), _c('p', [_vm._v(_vm._s(packageItem.dimension.replace(/x/g, ' x ')) + " cm "), _c('span', {
      staticClass: "text-neutral-500 font-medium"
    }, [_vm._v("(" + _vm._s(_vm.getVolumetricWeight(packageItem.dimension)) + " kg)")])])])]) : _vm._e()]);
  })], 2), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.deliveryService')))]), _c('div', {
    staticClass: "flex items-center gap-6 mb-6"
  }, [(_vm$orderDetail$order4 = _vm.orderDetail.order_delivery) !== null && _vm$orderDetail$order4 !== void 0 && _vm$orderDetail$order4.service_logo ? _c('img', {
    staticClass: "h-16 w-36 object-contain object-left",
    attrs: {
      "src": (_vm$orderDetail$order5 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order5 === void 0 ? void 0 : _vm$orderDetail$order5.service_logo
    }
  }) : _c('LogisticPlaceholder', {
    attrs: {
      "logisticName": (_vm$orderDetail$order6 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order6 === void 0 ? void 0 : _vm$orderDetail$order6.service_name
    }
  }), (_vm$orderDetail$order7 = _vm.orderDetail.order_delivery) !== null && _vm$orderDetail$order7 !== void 0 && _vm$orderDetail$order7.service_name ? _c('span', {
    staticClass: "text-sm text-secondary-500 bg-secondary-200 py-1 px-2 rounded-md"
  }, [_vm._v(_vm._s((_vm$orderDetail$order8 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order8 === void 0 ? void 0 : _vm$orderDetail$order8.service_name))]) : _vm._e()], 1), _c('div', {
    staticClass: "flex items-start gap-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.serviceType')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail$order9 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order9 === void 0 ? void 0 : _vm$orderDetail$order9.service_package_name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.serviceType')))]), _c('p', [_vm._v(_vm._s(_vm.getServiceType((_vm$orderDetail$order10 = _vm.orderDetail.order_delivery) === null || _vm$orderDetail$order10 === void 0 ? void 0 : _vm$orderDetail$order10.service_type) || '-'))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.senderInfo')))]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.senderName')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail6 = _vm.orderDetail) === null || _vm$orderDetail6 === void 0 ? void 0 : (_vm$orderDetail6$orde = _vm$orderDetail6.order_delivery) === null || _vm$orderDetail6$orde === void 0 ? void 0 : (_vm$orderDetail6$orde2 = _vm$orderDetail6$orde.sender) === null || _vm$orderDetail6$orde2 === void 0 ? void 0 : _vm$orderDetail6$orde2.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.senderPhone')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail7 = _vm.orderDetail) === null || _vm$orderDetail7 === void 0 ? void 0 : (_vm$orderDetail7$orde = _vm$orderDetail7.order_delivery) === null || _vm$orderDetail7$orde === void 0 ? void 0 : (_vm$orderDetail7$orde2 = _vm$orderDetail7$orde.sender) === null || _vm$orderDetail7$orde2 === void 0 ? void 0 : _vm$orderDetail7$orde2.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.senderAddress')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail8 = _vm.orderDetail) === null || _vm$orderDetail8 === void 0 ? void 0 : (_vm$orderDetail8$orde = _vm$orderDetail8.order_delivery) === null || _vm$orderDetail8$orde === void 0 ? void 0 : (_vm$orderDetail8$orde2 = _vm$orderDetail8$orde.sender) === null || _vm$orderDetail8$orde2 === void 0 ? void 0 : _vm$orderDetail8$orde2.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail9 = _vm.orderDetail) === null || _vm$orderDetail9 === void 0 ? void 0 : (_vm$orderDetail9$orde = _vm$orderDetail9.order_delivery) === null || _vm$orderDetail9$orde === void 0 ? void 0 : (_vm$orderDetail9$orde2 = _vm$orderDetail9$orde.sender) === null || _vm$orderDetail9$orde2 === void 0 ? void 0 : _vm$orderDetail9$orde2.detail_address) || '-'))])]), (_vm$orderDetail10 = _vm.orderDetail) !== null && _vm$orderDetail10 !== void 0 && (_vm$orderDetail10$ord = _vm$orderDetail10.order_delivery) !== null && _vm$orderDetail10$ord !== void 0 && _vm$orderDetail10$ord.has_pod ? _c('div', {
    staticClass: "mb-3 mt-6 flex items-center gap-4 w-full"
  }, [_c('div', {
    staticClass: "text-sm w-full p-4 flex items-center gap-2 bg-secondary-100 text-neutral-700 rounded-md"
  }, [_c('Info', {
    attrs: {
      "width": "24",
      "height": "24",
      "color": "neutral-700"
    }
  }), _vm._v(_vm._s(_vm.$t('order.orderDetail.pod')) + " ")], 1)]) : _vm._e()]), _c('div', {
    staticClass: "p-6 mdmax:shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.receiverInfo')))]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.receiverName')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail11 = _vm.orderDetail) === null || _vm$orderDetail11 === void 0 ? void 0 : (_vm$orderDetail11$ord = _vm$orderDetail11.order_delivery) === null || _vm$orderDetail11$ord === void 0 ? void 0 : (_vm$orderDetail11$ord2 = _vm$orderDetail11$ord.receiver) === null || _vm$orderDetail11$ord2 === void 0 ? void 0 : _vm$orderDetail11$ord2.name) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.receiverPhone')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail12 = _vm.orderDetail) === null || _vm$orderDetail12 === void 0 ? void 0 : (_vm$orderDetail12$ord = _vm$orderDetail12.order_delivery) === null || _vm$orderDetail12$ord === void 0 ? void 0 : (_vm$orderDetail12$ord2 = _vm$orderDetail12$ord.receiver) === null || _vm$orderDetail12$ord2 === void 0 ? void 0 : _vm$orderDetail12$ord2.phone_number) || '-'))])])]), _c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.receiverAddress')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail13 = _vm.orderDetail) === null || _vm$orderDetail13 === void 0 ? void 0 : (_vm$orderDetail13$ord = _vm$orderDetail13.order_delivery) === null || _vm$orderDetail13$ord === void 0 ? void 0 : (_vm$orderDetail13$ord2 = _vm$orderDetail13$ord.receiver) === null || _vm$orderDetail13$ord2 === void 0 ? void 0 : _vm$orderDetail13$ord2.address) || '-'))]), _c('div', {
    staticClass: "mt-6 p-2 bg-neutral-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Detail Pickup")]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail14 = _vm.orderDetail) === null || _vm$orderDetail14 === void 0 ? void 0 : (_vm$orderDetail14$ord = _vm$orderDetail14.order_delivery) === null || _vm$orderDetail14$ord === void 0 ? void 0 : (_vm$orderDetail14$ord2 = _vm$orderDetail14$ord.receiver) === null || _vm$orderDetail14$ord2 === void 0 ? void 0 : _vm$orderDetail14$ord2.detail_address) || '-'))])])])]), _c('div', {
    staticClass: "flex-1 shadow-border-l mdmax:shadow-none"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.packagePhoto')))]), _vm._l((_vm$orderDetail15 = _vm.orderDetail) === null || _vm$orderDetail15 === void 0 ? void 0 : (_vm$orderDetail15$ord = _vm$orderDetail15.order_delivery) === null || _vm$orderDetail15$ord === void 0 ? void 0 : _vm$orderDetail15$ord.packages, function (paket, index) {
    return _c('div', {
      key: 'paket-' + index,
      staticClass: "mb-4"
    }, [paket.photo_from_courier ? [_c('img', {
      attrs: {
        "src": paket.photo_from_courier
      }
    })] : _c('p', [_vm._v("- " + _vm._s(_vm.$t('order.orderDetail.photoNotAvailable')) + " -")])], 2);
  })], 2), (_vm$orderDetail16 = _vm.orderDetail) !== null && _vm$orderDetail16 !== void 0 && _vm$orderDetail16.price_adjustment ? _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.priceAdjustment')))]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.status')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail17 = _vm.orderDetail) === null || _vm$orderDetail17 === void 0 ? void 0 : (_vm$orderDetail17$pri = _vm$orderDetail17.price_adjustment) === null || _vm$orderDetail17$pri === void 0 ? void 0 : _vm$orderDetail17$pri.status) || '-'))])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.oldWeight')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail18 = _vm.orderDetail) === null || _vm$orderDetail18 === void 0 ? void 0 : (_vm$orderDetail18$pri = _vm$orderDetail18.price_adjustment) === null || _vm$orderDetail18$pri === void 0 ? void 0 : _vm$orderDetail18$pri.old_weight) || '-') + " kg")])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.newWeight')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail19 = _vm.orderDetail) === null || _vm$orderDetail19 === void 0 ? void 0 : (_vm$orderDetail19$pri = _vm$orderDetail19.price_adjustment) === null || _vm$orderDetail19$pri === void 0 ? void 0 : _vm$orderDetail19$pri.new_weight) || '-') + " kg")])])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.oldDimension')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail20 = _vm.orderDetail) === null || _vm$orderDetail20 === void 0 ? void 0 : (_vm$orderDetail20$pri = _vm$orderDetail20.price_adjustment) === null || _vm$orderDetail20$pri === void 0 ? void 0 : _vm$orderDetail20$pri.old_dimension) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.newDimension')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail21 = _vm.orderDetail) === null || _vm$orderDetail21 === void 0 ? void 0 : (_vm$orderDetail21$pri = _vm$orderDetail21.price_adjustment) === null || _vm$orderDetail21$pri === void 0 ? void 0 : _vm$orderDetail21$pri.new_dimension) || '-'))])])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.oldPrice')))]), _c('p', [_vm._v("Rp " + _vm._s(((_vm$orderDetail22 = _vm.orderDetail) === null || _vm$orderDetail22 === void 0 ? void 0 : (_vm$orderDetail22$pri = _vm$orderDetail22.price_adjustment) === null || _vm$orderDetail22$pri === void 0 ? void 0 : (_vm$orderDetail22$pri2 = _vm$orderDetail22$pri.old_price) === null || _vm$orderDetail22$pri2 === void 0 ? void 0 : _vm$orderDetail22$pri2.toLocaleString('id-ID')) || '0'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.newPrice')))]), _c('p', [_vm._v("Rp " + _vm._s(((_vm$orderDetail23 = _vm.orderDetail) === null || _vm$orderDetail23 === void 0 ? void 0 : (_vm$orderDetail23$pri = _vm$orderDetail23.price_adjustment) === null || _vm$orderDetail23$pri === void 0 ? void 0 : (_vm$orderDetail23$pri2 = _vm$orderDetail23$pri.new_price) === null || _vm$orderDetail23$pri2 === void 0 ? void 0 : _vm$orderDetail23$pri2.toLocaleString('id-ID')) || '0'))])])]), ((_vm$orderDetail24 = _vm.orderDetail) === null || _vm$orderDetail24 === void 0 ? void 0 : (_vm$orderDetail24$pri = _vm$orderDetail24.price_adjustment) === null || _vm$orderDetail24$pri === void 0 ? void 0 : _vm$orderDetail24$pri.status) === 'Pending Additional Payment' ? _c('div', {
    staticClass: "mb-6 p-4 bg-secondary-50 border border-secondary-200 rounded-md"
  }, [_c('p', {
    staticClass: "text-base font-bold mb-4 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.paymentAccountInfo')))]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-3"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.accountName')))]), _c('p', {
    staticClass: "font-semibold"
  }, [_vm._v("LINKNOW PUTELLA DIGITAL")])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.accountBank')))]), _c('p', {
    staticClass: "font-semibold"
  }, [_vm._v("Mandiri")])])]), _c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.accountNumberLabel')))]), _c('p', {
    staticClass: "font-semibold text-lg"
  }, [_vm._v("1010011736731")])])]) : _vm._e(), ((_vm$orderDetail25 = _vm.orderDetail) === null || _vm$orderDetail25 === void 0 ? void 0 : (_vm$orderDetail25$pri = _vm$orderDetail25.price_adjustment) === null || _vm$orderDetail25$pri === void 0 ? void 0 : _vm$orderDetail25$pri.status) === 'Pending Additional Payment' ? _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('order.orderDetail.markAsPaid'),
      "type": "primary",
      "size": "small"
    },
    on: {
      "action": function action($event) {
        return _vm.togglePriceAdjustmentModal();
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.paymentInfo')))]), _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.status')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail26 = _vm.orderDetail) === null || _vm$orderDetail26 === void 0 ? void 0 : (_vm$orderDetail26$pay = _vm$orderDetail26.payment_info) === null || _vm$orderDetail26$pay === void 0 ? void 0 : _vm$orderDetail26$pay.status_display) || '-'))])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.paymentType')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail27 = _vm.orderDetail) === null || _vm$orderDetail27 === void 0 ? void 0 : (_vm$orderDetail27$pay = _vm$orderDetail27.payment_info) === null || _vm$orderDetail27$pay === void 0 ? void 0 : _vm$orderDetail27$pay.payment_method) || '-'))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.bank')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail28 = _vm.orderDetail) === null || _vm$orderDetail28 === void 0 ? void 0 : (_vm$orderDetail28$pay = _vm$orderDetail28.payment_info) === null || _vm$orderDetail28$pay === void 0 ? void 0 : _vm$orderDetail28$pay.payment_provider) || '-'))])])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.accountNumber')))]), _c('p', [_vm._v(_vm._s(((_vm$orderDetail29 = _vm.orderDetail) === null || _vm$orderDetail29 === void 0 ? void 0 : (_vm$orderDetail29$pay = _vm$orderDetail29.payment_info) === null || _vm$orderDetail29$pay === void 0 ? void 0 : _vm$orderDetail29$pay.payment_account_display) || '-'))])])]), (_vm$orderDetail30 = _vm.orderDetail) !== null && _vm$orderDetail30 !== void 0 && (_vm$orderDetail30$pay = _vm$orderDetail30.payment_info) !== null && _vm$orderDetail30$pay !== void 0 && _vm$orderDetail30$pay.voucher_info ? _c('div', {
    staticClass: "mb-6"
  }, [_c('p', {
    staticClass: "text-sm font-medium mb-3 text-neutral-700"
  }, [_vm._v("Voucher Applied")]), _c('div', {
    staticClass: "mb-3"
  }, [_c('p', {
    staticClass: "text-xs font-medium mb-1 text-neutral-700"
  }, [_vm._v("Voucher Name")]), _c('p', {
    staticClass: "text-sm text-neutral-900"
  }, [_vm._v(_vm._s(_vm.orderDetail.payment_info.voucher_info.voucher_name))])]), _c('div', {
    staticClass: "flex justify-start gap-6 mb-3"
  }, [_c('div', {
    staticClass: "w-2/5"
  }, [_c('p', {
    staticClass: "text-xs font-medium mb-1 text-neutral-700"
  }, [_vm._v("Voucher Code")]), _c('p', {
    staticClass: "text-sm text-neutral-900"
  }, [_vm._v(_vm._s(_vm.orderDetail.payment_info.voucher_info.voucher_code))])]), _c('div', {
    staticClass: "w-3/5"
  }, [_c('p', {
    staticClass: "text-xs font-medium mb-1 text-neutral-700"
  }, [_vm._v("Discount Amount")]), _c('p', {
    staticClass: "text-sm font-semibold text-green-600"
  }, [_vm._v("- Rp " + _vm._s(_vm._f("formatCurrency")(_vm.orderDetail.payment_info.voucher_info.voucher_amount)))])])])]) : _vm._e(), _c('div', {
    staticClass: "mb-6"
  }, [(_vm$orderDetail31 = _vm.orderDetail) !== null && _vm$orderDetail31 !== void 0 && (_vm$orderDetail31$pay = _vm$orderDetail31.payment_info) !== null && _vm$orderDetail31$pay !== void 0 && _vm$orderDetail31$pay.voucher_info ? _c('div', {
    staticClass: "pt-3 border-t border-neutral-300"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('p', {
    staticClass: "text-xs text-neutral-700"
  }, [_vm._v("Price Before Discount")]), _c('p', {
    staticClass: "text-sm text-neutral-500 line-through"
  }, [_vm._v("Rp " + _vm._s(_vm._f("formatCurrency")(_vm.priceBeforeDiscount)))])]), _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('p', {
    staticClass: "text-xs font-bold text-neutral-700"
  }, [_vm._v("Price After Discount")]), _c('p', {
    staticClass: "text-sm font-bold text-green-700"
  }, [_vm._v("Rp " + _vm._s(_vm._f("formatCurrency")(_vm.orderDetail.payment_info.price)))])])]) : _c('div', [_c('p', {
    staticClass: "text-sm font-medium mb-1 text-neutral-700"
  }, [_vm._v("Total Price")]), _c('p', {
    staticClass: "text-sm font-bold text-neutral-900"
  }, [_vm._v("Rp " + _vm._s(_vm._f("formatCurrency")((_vm$orderDetail32 = _vm.orderDetail) === null || _vm$orderDetail32 === void 0 ? void 0 : (_vm$orderDetail32$pay = _vm$orderDetail32.payment_info) === null || _vm$orderDetail32$pay === void 0 ? void 0 : _vm$orderDetail32$pay.price)))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "text-xl font-bold mb-6 text-neutral-700"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.deliveryStatus')))]), _vm._l((_vm$orderDetail33 = _vm.orderDetail) === null || _vm$orderDetail33 === void 0 ? void 0 : _vm$orderDetail33.tracking_infos, function (tracking, index) {
    return _c('div', {
      key: 'tracking' + index,
      staticClass: "flex gap-5"
    }, [_c('div', {
      staticClass: "line relative"
    }, [_c('span', {
      staticClass: "inline-block w-5 h-5 rounded-full  border-4  relative z-1",
      class: index === 0 ? 'bg-primary-500 border-primary-100' : 'bg-neutral-500 border-neutral-300'
    }), _c('span', {
      staticClass: "absolute border-dashed border-neutral-300 h-full w-px border left-1/2 transform -translate-x-1/2 top-0 z-0"
    })]), _c('div', {
      staticClass: "status mb-6"
    }, [_c('p', {
      staticClass: "text-sm mb-1"
    }, [_vm._v(_vm._s(tracking.time_display))]), _c('p', {
      staticClass: "text-neutral-700 mb-1"
    }, [_vm._v(_vm._s(tracking.main_info))]), _c('p', {
      staticClass: "text-sm"
    }, [_vm._v(_vm._s(tracking.additional_info))])])]);
  })], 2)])])]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleConfirmModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.statusChange')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.orderDetail.statusDesc')) + " ")])])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleConfirmModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.proceed();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleAddCostModal,
      "width": "660px",
      "id": "add-cost-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleAddCostModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6 text-neutral-700 text-left"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.underpaid')))]), _c('div', {
    staticClass: "flex items-center gap-6 text-left mb-6"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.length')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageLength,
      callback: function callback($$v) {
        _vm.packageLength = $$v;
      },
      expression: "packageLength"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.width')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageWidth,
      callback: function callback($$v) {
        _vm.packageWidth = $$v;
      },
      expression: "packageWidth"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)]), _c('div', {
    staticClass: "flex-1"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.height')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number"
    },
    model: {
      value: _vm.packageHeight,
      callback: function callback($$v) {
        _vm.packageHeight = $$v;
      },
      expression: "packageHeight"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("cm")])], 1)])]), _c('div', {
    staticClass: "text-left w-1/3 mb-10"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.additionalPrice')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "borderEnabled": "",
      "type": "number",
      "withIcon": ""
    },
    model: {
      value: _vm.packagePrice,
      callback: function callback($$v) {
        _vm.packagePrice = $$v;
      },
      expression: "packagePrice"
    }
  }), _c('span', {
    staticClass: "absolute text-neutral-700 left-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v("Rp")])], 1)]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tutup",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleAddCostModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Submit",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.rejectAddCost();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleOtherModal,
      "width": "600px",
      "id": "confirmation-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleOtherModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "p-1"
  }, [_c('p', {
    staticClass: "text-2xl font-bold mb-6 text-neutral-700 text-left"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.other')))]), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "placeholder": "Silakan tulis alasannya",
      "borderEnabled": "",
      "error": _vm.otherReasonError
    },
    model: {
      value: _vm.otherReason,
      callback: function callback($$v) {
        _vm.otherReason = $$v;
      },
      expression: "otherReason"
    }
  })], 1), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tutup",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleOtherModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Submit",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.rejectOther();
      }
    }
  })], 1)])])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visiblePreviewReceipt,
      "width": "700px",
      "id": "receipt-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.previewReceipt();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('Receipt', {
    attrs: {
      "orderDetail": _vm.orderDetail
    },
    on: {
      "close": function close($event) {
        return _vm.previewReceipt();
      }
    }
  })], 1)], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleComplainModal,
      "width": "600px",
      "id": "complain-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleComplainModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('Complain', {
    attrs: {
      "orderId": _vm.orderId
    },
    on: {
      "close": function close($event) {
        return _vm.toggleComplainModal();
      }
    }
  })], 1)], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleModalShippingLabel,
      "width": "600px",
      "id": "shipping-label-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.toggleModalShippingLabel();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.deliveryLabel')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.orderDetail.downloadLabelText')) + " ")])])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.toggleModalShippingLabel();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Download",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.downloadAndClose();
      }
    }
  })], 1)])], 2), _c('CancelOrderModal', {
    attrs: {
      "modal": _vm.visibleModalCancelOrder
    },
    on: {
      "toggle": function toggle($event) {
        return _vm.toggleModalCancelOrder();
      },
      "closeAll": function closeAll($event) {
        return _vm.closeAll();
      }
    }
  }), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visiblePriceAdjustmentModal,
      "width": "600px",
      "id": "price-adjustment-modal"
    },
    on: {
      "close": function close($event) {
        return _vm.togglePriceAdjustmentModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v(_vm._s(_vm.$t('order.orderDetail.markAsPaidConfirmTitle')))]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" " + _vm._s(_vm.$t('order.orderDetail.markAsPaidConfirmDesc')) + " ")])])]), _c('div', {
    staticClass: "flex justify-end gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.togglePriceAdjustmentModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function action($event) {
        return _vm.handlePriceAdjustmentAction();
      }
    }
  })], 1)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }